export { default } from './SeguroAuto25';
